import { render, staticRenderFns } from "./select-template.vue?vue&type=template&id=cfc48538&scoped=true"
import script from "./select-template.vue?vue&type=script&lang=ts"
export * from "./select-template.vue?vue&type=script&lang=ts"
import style0 from "./select-template.vue?vue&type=style&index=0&id=cfc48538&prod&lang=scss&scoped=true"
import style1 from "./select-template.vue?vue&type=style&index=1&id=cfc48538&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc48538",
  null
  
)

export default component.exports